import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { FlexCenterWrapper, CustomBackgroundWrapper, Mr1, Mr3, Mr14, GenericWrapper } from 'wrappers';
import { Icon, CustomText, ClickableIcon, SecondaryTextSm, CustomInput } from 'atoms';
import { priorityList } from 'utils';
import { TickSvg, EditPencilSvg } from 'components/icons';

export const definition = {
  name: 'PrioritySettingRow',
  controller: Controller,
  initialProps: ({ setting }) => ({ setting, inputVal: setting.value ?? '' }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(CustomBackgroundWrapper, Mr3),
      name: 'Wrapper',
      renderIf: ({ setting }) => priorityList.find(p => p.settingsCode === setting.name),
      displayState: ({ setting }) => ({
        borderRadius: '60px',
        background: priorityList.find(p => p.settingsCode === setting.name)?.background,
        padding: '4px 10px',
        alignItems: 'center',
      }),
      elements: [
        {
          component: wrap(Icon, Mr1),
          name: 'Icon',
          displayValue: ({ setting }) => priorityList.find(p => p.settingsCode === setting.name)?.icon
        },
        {
          component: CustomText,
          name: 'Text',
          renderIf: ({ isEditing }) => !isEditing,
          displayValue: ({ setting }) => setting?.value ?? '',
          displayState: ({ setting }) => ({ color: priorityList.find(p => p.settingsCode === setting.name)?.textColor })
        },
        {
          wrapper: GenericWrapper,
          name: '__transparent__',
          renderIf: ({ isEditing }) => isEditing,
          ref: ({ inputRef }) => inputRef ?? null,
          elements: [
            {
              component: CustomInput,
              name: 'Input',
              bindings: ({ inputVal }) => ({ value: inputVal }),
              displayState: ({ setting }) => ({
                color: priorityList.find(p => p.settingsCode === setting.name)?.textColor,
                border: 'none',
                borderBottom: '.5px solid #04333B',
                borderRadius: '0px',
                width: 'unset',
                height: '20px',
                fontSize: '10px',
                background: priorityList.find(p => p.settingsCode === setting.name)?.background,
              })
            },
          ]
        }
      ]
    },
    {
      component: wrap(ClickableIcon, Mr14),
      name: 'Button',
      bindings: ({ isEditing, inputRef, inputVal }) => ({ isEditing, inputRef, inputVal }),
      displayValue: ({ isEditing }) => isEditing ? TickSvg({ square: true, width: 16, height: 16 }) : EditPencilSvg({ width: 16, height: 16 })
    },
    {
      component: SecondaryTextSm,
      name: 'Text',
      displayValue: ({ setting }) => priorityList.find(p => p.settingsCode === setting.name)?.description ?? ''
    }

  ]
};

export default wrap(ContainerComponent(definition), FlexCenterWrapper);